(() => {
  if (window.__nutriscoRetailRocketInit) return;
  window.__nutriscoRetailRocketInit = true;

  function onRetailRocketReady(callback) {
    window.rrApiOnReady = window.rrApiOnReady || [];
    window.rrApiOnReady.push(() => {
      try {
        callback();
      } catch (error) {
        console.error('Retail Rocket callback error', error); // eslint-disable-line no-console
      }
    });
  }

  function getStoredRegion() {
    try {
      return (localStorage.getItem('region') || '').toUpperCase();
    } catch (e) {
      return '';
    }
  }

  function loadRegionRules() {
    const el = document.getElementById('nutrisco-region-product-rules');
    if (!el) return {};
    try {
      const raw = JSON.parse(el.textContent);
      const normalized = {};
      for (const tag in raw) {
        const regions = Array.isArray(raw[tag]) ? raw[tag] : [];
        normalized[tag.toLowerCase().trim()] = regions.map((r) => r.toUpperCase().trim());
      }
      return normalized;
    } catch (e) {
      return {};
    }
  }

  function isProductRestricted(productTags) {
    const region = getStoredRegion();
    if (!region) return false;
    const rules = loadRegionRules();
    const tags = typeof productTags === 'string'
      ? productTags.split(',').map((t) => t.trim().toLowerCase())
      : [];
    for (const ruleTag in rules) {
      if (tags.includes(ruleTag) && !rules[ruleTag].includes(region)) {
        return true;
      }
    }
    return false;
  }

  function getStockId() {
    try {
      return localStorage.getItem('comuna') || '';
    } catch (e) {
      return '';
    }
  }

  function applyStockIdToSlots() {
    const stockId = getStockId();
    if (!stockId) return;

    document.querySelectorAll('[data-retailrocket-markup-block]').forEach((el) => {
      el.setAttribute('stockId', stockId);
    });
  }

  function updateCongeladosAvailability() {
    if (!window.__rrProductData) return;

    const productEl = document.querySelector('.product.js-product[data-product-tags]');
    if (!productEl) return;

    const tags = productEl.getAttribute('data-product-tags');
    if (isProductRestricted(tags)) {
      // Aplica a grupo y variantes
      window.__rrProductData.isAvailable = false;
      const prods = window.__rrProductData.products;
      if (prods) {
        for (const vid in prods) {
          prods[vid].isAvailable = false;
        }
      }
    }
  }

  function renderRetailRocketMarkup() {
    applyStockIdToSlots();

    if (window.retailrocket && retailrocket.markup && typeof retailrocket.markup.render === 'function') {
      retailrocket.markup.render();
    }

    updateCongeladosAvailability();
  }

  function scheduleMarkupRender() {
    onRetailRocketReady(renderRetailRocketMarkup);
  }

  // Retorna el variant ID (itemId) para addToBasket
  function getProductId(form) {
    const variantInput = form && form.querySelector('input[name="id"]');
    if (variantInput && variantInput.value) return variantInput.value;

    const card = form && form.closest('[data-product-id]');
    if (card) return card.getAttribute('data-product-id');

    return null;
  }

  function trackAddToCart(form) {
    if (window.theme && theme.settings && theme.settings.retailRocketTrackAddToCart === false) return;

    const productId = getProductId(form);
    if (!productId) return;

    onRetailRocketReady(() => {
      if (window.rrApi && typeof rrApi.addToBasket === 'function') {
        const stockId = getStockId();
        rrApi.addToBasket(productId, { stockId });
        console.log('[RetailRocket] addToBasket:', productId, '{ stockId:', stockId, '}');
      }
    });
  }

  // Código 6: Captura de email en formularios
  function trackEmailCapture(form) {
    const emailInput = form.querySelector('input[name="contact[email]"], input[type="email"][name="contact[email]"]');
    if (!emailInput) return;

    const email = (emailInput.value || '').trim();
    if (!email) return;

    const stockId = getStockId();

    const payload = {
      customerId: email,
      email: email,
      customData: { stockId: stockId },
      defaultStockId: stockId,
      isAgreedToReceiveMarketingMail: true
    };

    // Nombre (formulario de contacto)
    const nameInput = form.querySelector('input[autocomplete="name"]');
    if (nameInput && nameInput.value.trim()) {
      payload.customData.name = nameInput.value.trim();
    }

    // Teléfono (formulario de contacto)
    const phoneInput = form.querySelector('input[type="tel"]');
    if (phoneInput && phoneInput.value.trim()) {
      payload.phone = phoneInput.value.trim();
    }

    onRetailRocketReady(() => {
      if (window.rrApi && typeof rrApi.setCustomer === 'function') {
        rrApi.setCustomer(payload);
        console.log('[RetailRocket] setCustomer:', payload);
      }
    });
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = form.getAttribute('action') || '';

      // Código 4: Add to cart
      if (action.includes('/cart/add')) {
        trackAddToCart(form);
        return;
      }

      // Código 6: Email capture (newsletter, contacto, popup)
      trackEmailCapture(form);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleMarkupRender, { once: true });
  } else {
    scheduleMarkupRender();
  }

  document.addEventListener('shopify:section:load', scheduleMarkupRender);
  document.addEventListener('on:line-item:change', scheduleMarkupRender);
  document.addEventListener('on:facet-filters:updated', scheduleMarkupRender);
  document.addEventListener('on:cart:add', scheduleMarkupRender);
  document.addEventListener('dispatch:cart-drawer:refresh', scheduleMarkupRender);
  document.addEventListener('on:cart-drawer:updated', () => {
    if (!document.querySelector('#cart-drawer [data-retailrocket-markup-block]')) return;

    if (window.retailrocket && retailrocket.markup && typeof retailrocket.markup.render === 'function') {
      renderRetailRocketMarkup();
    } else {
      scheduleMarkupRender();
    }
  });

  window.addEventListener('nutrisco:comuna-change', scheduleMarkupRender);
})();
